var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJaguarLogoUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 19.225q-.725 0-1.225-.5-.5-.5-.5-1.2v-2.65h1.4v2.65q0 .125.1.212.1.088.225.088h11.2q.125 0 .225-.088.1-.087.1-.212v-2.65h1.4v2.65q0 .7-.5 1.2t-1.225.5Zm4.9-3.675V7.2L8.875 9.625l-.975-1 4.1-4.1 4.1 4.1-.975 1L12.7 7.2v8.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaguarLogoUpload);
export default __webpack_public_path__ + "static/media/jaguar_logo_upload.22e0fb427c2cd4cf69dea7172ee93a15.svg";
export { ForwardRef as ReactComponent };